import { scheduleNonCriticalTask } from 'src/common/non-critical-task'

const INTERACTION_EVENTS = ['pointerdown', 'keydown', 'touchstart']
const INTERACTION_DELAY_MS = 1200
const LOAD_FALLBACK_DELAY_MS = 12000
const HARD_FALLBACK_MS = 25000

let sentryStarted = false
let scheduledAtTs = 0
let scheduleTimerId = null

async function startSentry(ctx) {
  if (sentryStarted) {
    return
  }

  sentryStarted = true

  try {
    const { default: initSentry } = await import('boot/sentry-logger')
    await initSentry(ctx)
  } catch (error) {
    console.error('[Sentry] lazy init failed', error)
  }
}

function scheduleSentry(ctx, delay = 0) {
  if (sentryStarted) {
    return
  }

  const runAtTs = Date.now() + Math.max(0, delay)

  if (scheduleTimerId && scheduledAtTs && runAtTs >= scheduledAtTs) {
    return
  }

  if (scheduleTimerId) {
    window.clearTimeout(scheduleTimerId)
    scheduleTimerId = null
  }

  scheduledAtTs = runAtTs

  scheduleTimerId = window.setTimeout(
    () => {
      scheduleTimerId = null
      scheduledAtTs = 0
      scheduleNonCriticalTask(
        () => {
          void startSentry(ctx)
        },
        {
          timeout: 3000,
          fallbackDelay: 300,
        },
      )
    },
    Math.max(0, delay),
  )
}

export function scheduleLazySentryInit(ctx) {
  if (typeof window === 'undefined') {
    return
  }

  const onFirstInteraction = () => {
    cleanupInteractionListeners()
    scheduleSentry(ctx, INTERACTION_DELAY_MS)
  }

  const cleanupInteractionListeners = () => {
    INTERACTION_EVENTS.forEach((eventName) => {
      window.removeEventListener(eventName, onFirstInteraction)
    })
  }

  INTERACTION_EVENTS.forEach((eventName) => {
    window.addEventListener(eventName, onFirstInteraction, { once: true, passive: true })
  })

  if (document.readyState === 'complete') {
    scheduleSentry(ctx, LOAD_FALLBACK_DELAY_MS)
  } else {
    window.addEventListener(
      'load',
      () => {
        scheduleSentry(ctx, LOAD_FALLBACK_DELAY_MS)
      },
      { once: true },
    )
  }

  window.setTimeout(() => {
    scheduleSentry(ctx, 0)
  }, HARD_FALLBACK_MS)
}
